import { escapeCell } from '../TagBlockersDialog';

export interface IPromotionConflict {
  tagName: string;
  scenarioName: string;
}

// CLD-3103: names come from the API, so cells go through the formula-safe escapeCell.
export const downloadPromotionConflictsCsv = (
  conflicts: IPromotionConflict[]
): void => {
  const rows = [
    ['Submission Tag', 'Scenario'],
    ...conflicts.map((c) => [c.tagName, c.scenarioName]),
  ].map((row) => row.map(escapeCell).join(','));

  const blob = new Blob([rows.join('\r\n')], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'submission-tag-conflicts.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
